



















































import { defineComponent, ref } from '@vue/composition-api'
import isEmpty from 'validator/es/lib/isEmpty'
import { API } from '../../api'

export default defineComponent({
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root, emit }) {
    const teamNameModel = ref<string>('')
    const valid = ref(false)
    const snackbar = ref(false)
    const isSubmitting = ref(false)
    const formRef = ref<any>()

    async function submit(event: Event) {
      event.preventDefault()
      event.stopPropagation()
      isSubmitting.value = true
      const response = await API.Tournament.addTeam(root.$route.params.hash, {
        name: teamNameModel.value,
      })
      if (response.isSuccessful) {
        teamNameModel.value = ''
        emit('input', response.data)
        formRef.value.resetValidation()
      } else {
        snackbar.value = true
      }
      isSubmitting.value = false
    }

    return {
      formRef,
      snackbar,
      valid,
      teamNameModel,
      isSubmitting,
      submit,
      rules: {
        isRequired: (value: string) =>
          !isEmpty(value) || root.$i18n.t('common.form.required'),
      },
    }
  },
})
